import { motion } from 'framer-motion'
import React, { FC } from 'react'

import ImageByWidthDevice from '@/components/ImageByWidthDevice'
import { introOpacityVariants } from '@/config/const'
import { ImageResponsive } from '@/types/common'
import clsxm from '@/utils/clsxm'
import { useResponsiveImage } from '@/utils/hooks'
const MapContent: FC<{
  images: ImageResponsive
  active: boolean
  legendImageFiles?: ImageResponsive
}> = ({ images, legendImageFiles, active }) => {
  const imageUrl = useResponsiveImage(images)
  return (
    <motion.div
      className={clsxm(
        'relative h-[295px] bg-repeat-round md:h-[423px] lg:h-[calc(100vh-75px)]',
        active ? 'block' : 'hidden'
      )}
      style={{ backgroundImage: `url('${imageUrl ?? ''}')` }}
      initial='hide'
      whileInView='show'
      exit='hide'
      variants={introOpacityVariants}
      viewport={{ once: true }}
    >
      {legendImageFiles && (
        <div className='absolute inset-x-5 bottom-3'>
          <ImageByWidthDevice
            images={legendImageFiles}
            alt='legends'
            className={clsxm('block w-full lg:hidden', active ? 'block' : 'hidden')}
          />
        </div>
      )}
    </motion.div>
  )
}

export default MapContent
